import { styled } from "styled-components";
import { getBounds } from "../../utils/calculations";

const Root = styled.div`
  border-radius: 100%;
  border: var(--border-width) var(--border-style) var(--color-theme-secondary-500);
  height: ${props => props.$size}px;
  left: ${props => props.$x}px;
  position: absolute;
  top: ${props => props.$y}px;
  translate: -50% -50%;
  width: ${props => props.$size}px;
  z-index: -1;
`;

function getSize(bounds, x, y, center) {
  const x2 = (center.x - x) ** 2;
  const y2 = (center.y - y) ** 2;

  return Math.sqrt(x2 + y2);
}

function getCenter(bounds) {
  const x = (Math.abs(bounds.minx) + Math.abs(bounds.maxx)) * 5;
  const y = (Math.abs(bounds.miny) + Math.abs(bounds.maxy)) * 5;

  return { x, y };
}

function remapWaypoint(bounds, x, y, place) {
  x = ((x + Math.abs(bounds.minx)) * 10) + ((place - 1) * 25);
  y = ((y + Math.abs(bounds.miny)) * 10) + ((place - 1) * 25);

  return { x, y };
}

function Orbit({ store, waypoint, zoom }) {
  const bounds = getBounds(store.state.system.waypoints);
  const coord = getCenter(bounds);
  const waypointCoord = remapWaypoint(bounds, waypoint.x, waypoint.y, 1);
  const size = getSize(bounds, waypointCoord.x, waypointCoord.y, coord);

  if (waypoint.type == 'MOON' || waypoint.type == 'ORBITAL_STATION') {
    return;
  }

  return (
    <Root $x={coord.x} $y={coord.y} $size={size * 2}>
    </Root>
  );
}

export default Orbit;
